import React from "react";
import Icon from "../Icon";

const SortHeader = ({ index, ordenationItem, orientation, onSort, indexMap }) => {
    const getMappedValue = (index) => {
        return indexMap.find(item => item.index === index)?.value;
    };

    const mappedValue = getMappedValue(index);
    if (!mappedValue) return index;

    const isActive = ordenationItem === mappedValue;
    const icon = isActive ? (orientation === 'asc' ? 'sort_asc' : 'sort_desc') : 'sort';

    const handleClick = () => {
        const newOrientation = isActive && orientation === 'asc' ? 'desc' : 'asc';
        onSort(mappedValue, newOrientation);
    };

    return (
        <div className="sort-header" onClick={handleClick}>
            <span className="sort-header__label">{index}</span>
            <Icon
                name={icon}
                size={14}
                strokeWidth={1.5}
                className={`sort-header__icon${isActive ? ' is-active' : ''}`}
            />
        </div>
    );
};

export default SortHeader;
